// Administrator.model.ts
import { AppUser, IAppUser } from "./app-user.model";

export interface IAdministrator {
  uidAdministrator: string;
  neighborhoodId: string;
  isOwner: boolean;
  paymentsNotification: boolean;
  reportsNotification: boolean;
  administrator?: IAppUser;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export class Administrator {
  uidAdministrator: string;
  neighborhoodId: string;
  isOwner: boolean;
  paymentsNotification: boolean;
  reportsNotification: boolean;
  administrator?: AppUser;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IAdministrator) {
    this.uidAdministrator = data.uidAdministrator;
    this.neighborhoodId = data.neighborhoodId;
    this.isOwner = data.isOwner;
    this.paymentsNotification = data.paymentsNotification;
    this.reportsNotification = data.reportsNotification;
    this.administrator = data.administrator
      ? new AppUser(data.administrator)
      : undefined;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }

  get uid(): string {
    return this.uidAdministrator;
  }

  get email(): string {
    return this.administrator?.email ?? '';
  }

  get fullName(): string {
    return this.administrator?.fullName ?? '';
  }

}
